import React from 'react';
import { useLang } from '@/contexts/LanguageContext';
import { IMAGES } from '@/data/brand';

export default function About() {
  const { t } = useLang();

  return (
    <div className="bg-[#FFFBFB]">
      <section className="px-6 md:px-12 lg:px-24 pt-16 md:pt-24 pb-20 md:pb-28">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <p className="text-[10px] md:text-xs font-bold tracking-[0.3em] uppercase text-[#FF7597]">
              {t('about.eyebrow')}
            </p>
            <h1 className="font-display mt-3 text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter text-[#1F1A24] text-balance">
              {t('about.title')}
            </h1>
            <p className="mt-6 text-lg md:text-xl text-[#1F1A24]/80 leading-relaxed text-balance">
              {t('about.lead')}
            </p>
          </div>
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="rounded-[2.5rem] overflow-hidden aspect-[4/5] bg-[#F6EDFA]">
                <img src={IMAGES.brandLifestyle} alt="Jelly lifestyle" className="w-full h-full object-cover" />
              </div>
              <div className="absolute -bottom-6 -left-6 bg-[#FF7597] text-white p-5 rounded-3xl shadow-xl">
                <p className="text-[10px] font-bold tracking-[0.3em] uppercase">since 2004</p>
                <p className="font-display text-3xl font-black tracking-tighter">+20 años</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-24 py-20 bg-[#FFF2F5]">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <p className="font-display text-3xl md:text-4xl font-bold tracking-tight text-[#1F1A24] text-balance">
              {t('about.p1')}
            </p>
          </div>
          <div>
            <p className="text-base md:text-lg text-[#574A66] leading-relaxed">
              {t('about.p2')}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
